var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54951)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.8519C26.8406 9.85085 25.7922 9.41602 25.0191 8.64285C24.2459 7.86968 23.8111 6.82133 23.81 5.72791V0.00390625H5.382C3.95495 0.00390615 2.58632 0.570665 1.57706 1.57955C0.567794 2.58844 0.000530304 3.95686 0 5.3839V37.8279C0.00159014 39.2543 0.569321 40.6217 1.57847 41.6297C2.58762 42.6377 3.95564 43.2039 5.382 43.2039H27.502C28.2089 43.2042 28.909 43.0652 29.5622 42.7948C30.2154 42.5244 30.809 42.1281 31.3089 41.6283C31.8089 41.1285 32.2055 40.5351 32.4761 39.882C32.7467 39.2289 32.886 38.5289 32.886 37.8219V9.8519H27.934Z",
    fill: "#F97316"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8861 9.8519H27.9341C26.8406 9.85084 25.7923 9.41602 25.0191 8.64285C24.246 7.86968 23.8111 6.82133 23.8101 5.7279V0.00390625L32.8861 9.8519Z",
    fill: "#F97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7879 34.1239H11.7799C10.0059 34.1239 8.56787 35.562 8.56787 37.3359V44.7919C8.56787 46.5658 10.0059 48.0039 11.7799 48.0039H36.7879C38.5618 48.0039 39.9999 46.5658 39.9999 44.7919V37.3359C39.9999 35.562 38.5618 34.1239 36.7879 34.1239Z",
    fill: "#F97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 42.6779V44.1319H11.894V42.6779H13.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.332 38.1179L20.894 44.1319H19.094L18.134 40.1079L17.164 44.1319H15.364L13.926 38.1179H15.508L16.282 42.4739L17.338 38.1179H18.938L19.994 42.4739L20.776 38.1179H22.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8601 38.1599V44.1319H28.4001V40.4039L27.1061 44.1379H25.8481L24.5461 40.3959V44.1379H23.0901V38.1659H24.8681L26.4941 42.3259L28.0841 38.1659L29.8601 38.1599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5999 43.0339H32.3359L31.9599 44.1319H30.4299L32.6299 38.1599H34.3059L36.5059 44.1319H34.9579L34.5999 43.0339ZM34.2259 41.9279L33.4759 39.7179L32.7199 41.9279H34.2259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.53 26.3879H21.34V17.5359C21.34 17.2394 21.2222 16.9551 21.0125 16.7454C20.8028 16.5357 20.5185 16.4179 20.222 16.4179H14.622C14.3254 16.4179 14.0411 16.5357 13.8314 16.7454C13.6217 16.9551 13.504 17.2394 13.504 17.5359V26.3879H11.304V16.7879C11.3045 16.1077 11.5751 15.4556 12.0562 14.9748C12.5374 14.494 13.1898 14.2239 13.87 14.2239H20.952C21.632 14.2239 22.2841 14.4941 22.765 14.9749C23.2458 15.4558 23.516 16.1079 23.516 16.7879L23.53 26.3879Z",
    fill: "#F97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9339 28.9839C22.3676 28.9839 23.5299 27.8216 23.5299 26.3879C23.5299 24.9542 22.3676 23.7919 20.9339 23.7919C19.5002 23.7919 18.3379 24.9542 18.3379 26.3879C18.3379 27.8216 19.5002 28.9839 20.9339 28.9839Z",
    fill: "#F97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.92 28.9839C12.3537 28.9839 13.516 27.8216 13.516 26.3879C13.516 24.9542 12.3537 23.7919 10.92 23.7919C9.48624 23.7919 8.32397 24.9542 8.32397 26.3879C8.32397 27.8216 9.48624 28.9839 10.92 28.9839Z",
    fill: "#F97316"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWma);
export default __webpack_public_path__ + "static/media/wma.b7cd5aaa8ebfe33b385bab3e4c5061e3.svg";
export { ForwardRef as ReactComponent };